module.exports = __webpack_public_path__ + "img/Form_Inactive.2094b81d.svg";